import { useHistory } from "react-router-dom"

import { useScenario } from "../contexts/ScenarioContext"

const SubPhaseNav = ({ baseURL, activeColor, id, label, phase}) => {
    const {currPhase, currSubPhase } = useScenario()
    const history = useHistory()

    const clickHandler = (event) => {
        history.push(`${baseURL}/${phase}/${id}`)
    }

    // #566573
    return (
        <div
            className="subphase-nav"
        >
            <button
                id={id}
                style={{
                    color: (currSubPhase === id | currPhase !== phase) ? "white" : "black",
                    backgroundColor: (currSubPhase === id) ? "black" : "transparent"
                }}
                onClick={clickHandler}
            >
                {label}
            </button>
        </div>
    )
}

export default SubPhaseNav